export default {"src":"/_next/static/media/expert-icon.5f0b3bf3.svg","height":20,"width":20};